import api from "./axios";

export const getCheckoutSettings = () => api.get("/checkout/settings");
export const updateCheckoutSettings = (data) => api.patch("/checkout/settings", data);
